export const MAP2024_MAP_PREFIX = "FR-MAP-CASH-TVBM";
